import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Punetohampibadambusonrentservice() {



  const cardData =
  {
    keyword: 'Pune to Hampi Badami Bus on Rent Services',
    heading: 'Sanavi Travels: Pune to Hampi Badami Bus on Rent Services',
    headingDescription: 'Sanavi Travels offers Pune to Hampi Badami Bus on Rent Services, providing safe, comfortable, and well-organized transportation for heritage tours, group travel, corporate outings, school trips, and family vacations. Our fleet of well-maintained AC and Non-AC buses, mini buses, and luxury coaches ensures spacious seating, smooth rides, and ample luggage space for long-distance journeys. With professional drivers, flexible one-way and round-trip bus rental options, transparent pricing, and 24/7 booking support, our Pune to Hampi Badami bus rental services guarantee punctual, reliable, and stress-free travel. Choose Sanavi Travels for a seamless Pune to Hampi Badami bus hire, combining comfort, safety, and convenience for a memorable heritage tour experience.',

    top: 'Top Places to Visit in Hampi Badami with Sanavi Travels',


"topPlaces": [
  {
    "title": "Hampi – UNESCO World Heritage Site",
    "description": "Hampi is one of India’s most extraordinary historical destinations and a UNESCO World Heritage Site, located on the banks of the Tungabhadra River in Karnataka. Once the grand capital of the Vijayanagara Empire, Hampi is renowned for its vast landscape of ruins, majestic temples, royal enclosures, stone chariots, and massive boulders scattered across the terrain. The Virupaksha Temple remains an active place of worship, while monuments like Vittala Temple with its iconic stone chariot showcase the architectural brilliance of the empire. Hampi offers a mesmerizing blend of history, spirituality, archaeology, and surreal natural beauty, attracting historians, photographers, backpackers, and spiritual seekers from across the world."
  },
  {
    "title": "Virupaksha Temple, Hampi",
    "description": "The Virupaksha Temple is the spiritual heart of Hampi and one of the oldest functioning temples in India. Dedicated to Lord Shiva, this temple predates the Vijayanagara Empire and later became its religious center. The towering gopuram, intricate carvings, sacred corridors, and temple rituals create a deeply divine atmosphere. Pilgrims believe that worship here brings spiritual fulfillment and blessings. The temple complex comes alive during festivals like Hampi Utsav and Maha Shivratri."
  },
  {
    "title": "Vittala Temple & Stone Chariot",
    "description": "The Vittala Temple is the most iconic monument of Hampi, famous for its stone chariot and musical pillars. Dedicated to Lord Vittala (a form of Vishnu), the temple complex reflects advanced engineering and artistic excellence. The musical pillars, when tapped, produce resonant sounds, showcasing the scientific brilliance of ancient architects. This site is a major attraction for tourists and historians alike."
  },
  {
    "title": "Badami Cave Temples",
    "description": "Badami is famous for its ancient rock-cut cave temples carved into red sandstone cliffs overlooking Agastya Lake. Dating back to the 6th century during the Chalukya dynasty, the caves are dedicated to Hindu deities Shiva, Vishnu, and Jain Tirthankaras. The intricate carvings, sculptures, and architectural symmetry reflect early Indian temple artistry. Badami stands as a testament to Karnataka’s ancient cultural and religious heritage."
  },
  {
    "title": "Agastya Lake, Badami",
    "description": "Agastya Lake lies at the heart of Badami, surrounded by cave temples, forts, and cliffs. According to legend, the sage Agastya purified the waters here. The lake enhances the scenic charm of Badami and offers a tranquil setting, especially during sunrise and sunset. The reflections of the caves and hills in the calm waters create a breathtaking visual experience."
  },
  {
    "title": "Badami Fort",
    "description": "Badami Fort sits atop a hill overlooking the town and Agastya Lake, offering panoramic views of the surrounding landscape. The fort includes ancient watchtowers, granaries, and temples dating back to the Chalukya period. Reaching the fort involves a scenic climb, rewarding visitors with sweeping views and a deeper understanding of Badami’s strategic and historical importance."
  },
  {
    "title": "Pattadakal (Nearby Heritage Site)",
    "description": "Located near Badami, Pattadakal is another UNESCO World Heritage Site known for its exquisite group of temples built in both Dravidian and Nagara architectural styles. These temples were used for royal coronations of Chalukya kings. The detailed carvings and harmonious design make Pattadakal an essential stop for heritage and architecture enthusiasts."
  },
  {
    "title": "Aihole (Cradle of Temple Architecture)",
    "description": "Aihole, located close to Badami, is considered the birthplace of Indian temple architecture. It houses over 100 ancient temples showcasing experimental styles and layouts. Aihole provides valuable insight into the evolution of Hindu temple construction and is a paradise for history lovers."
  },
  {
    "title": "Cultural and Historical Significance",
    "description": "Together, Hampi and Badami represent the golden chapters of South Indian history, showcasing the rise and fall of powerful empires like the Vijayanagara and Chalukyas. These destinations reflect India’s artistic excellence, spiritual depth, and architectural innovation, making them culturally invaluable."
  },
  {
    "title": "Heritage Tourism Circuit",
    "description": "Hampi and Badami form a popular heritage tourism circuit along with Aihole and Pattadakal. This circuit offers travelers a complete journey through ancient Indian civilization, combining archaeology, spirituality, scenic landscapes, and cultural immersion. It is ideal for history enthusiasts, scholars, and travelers seeking meaningful exploration."
  }
]
,



"services": [
{
"name": "Pune to Hampi Badami Bus On Rent Services",
"description": "Pune to Hampi Badami Bus On Rent Services provides reliable and comfortable bus rental solutions for travelers planning a heritage tour to Karnataka. Ideal for families, groups, and organizations, this service ensures well-maintained buses, spacious seating, and smooth long-distance travel. With experienced drivers and planned routes, passengers can enjoy a safe, relaxed, and enjoyable journey from Pune to the historic destinations of Hampi and Badami."
},
{
"name": "Hampi Badami Bus Hire from Pune",
"description": "Hampi Badami Bus Hire from Pune offers convenient and organized transportation for heritage tours and sightseeing trips. Designed for group travel, this service focuses on punctual departures, comfortable buses, and professional chauffeurs. It helps travelers explore Hampi and Badami temples, monuments, and cultural sites without worrying about travel logistics."
},
{
"name": "AC Bus Pune to Hampi",
"description": "AC Bus Pune to Hampi ensures a comfortable and refreshing travel experience with fully air-conditioned buses. Perfect for long journeys, summer travel, and family trips, these buses provide relaxed seating, smooth rides, and climate-controlled comfort, allowing passengers to travel long distances with ease and convenience."
},
{
"name": "Luxury Bus Hampi Badami Tour",
"description": "Luxury Bus Hampi Badami Tour delivers a premium travel experience with modern interiors, pushback seats, and enhanced comfort features. Ideal for corporate groups, VIP travelers, and special tours, this service combines style, safety, and comfort, making the heritage journey memorable and stress-free."
},
{
"name": "Heritage Tour Bus Pune",
"description": "Heritage Tour Bus Pune is specially designed for travelers exploring historical and cultural destinations like Hampi and Badami. With knowledgeable drivers, comfortable buses, and well-planned itineraries, this service supports a smooth sightseeing experience, allowing travelers to focus on history, architecture, and culture."
},
{
"name": "Family Hampi Badami Trip",
"description": "Family Hampi Badami Trip bus services cater to families seeking safe, comfortable, and organized travel. Spacious seating, smooth driving, and reliable schedules ensure a pleasant journey for all age groups, making it ideal for family vacations and heritage tours."
},
{
"name": "Group Travel Hampi Bus",
"description": "Group Travel Hampi Bus offers efficient transportation for friends, tour groups, educational trips, and corporate teams. With large-capacity buses, professional chauffeurs, and coordinated travel planning, this service ensures comfortable, safe, and well-managed group journeys."
},
{
"name": "Affordable Hampi Bus Rental",
"description": "Affordable Hampi Bus Rental provides cost-effective bus rental options without compromising on comfort or safety. Suitable for budget-conscious travelers, families, and groups, this service offers transparent pricing, dependable buses, and professional drivers for economical long-distance travel."
},
{
"name": "Chauffeur Driven Bus Hampi",
"description": "Chauffeur Driven Bus Hampi ensures a hassle-free travel experience with skilled drivers managing routes, traffic, and schedules. Ideal for long-distance tours, heritage trips, and group travel, this service emphasizes passenger safety, punctuality, and smooth driving throughout the journey."
},
{
"name": "Best Bus Service Pune to Hampi",
"description": "Best Bus Service Pune to Hampi is known for quality buses, reliable service, and customer satisfaction. Suitable for family tours, group travel, and heritage trips, it prioritizes comfort, safety standards, and timely transportation for a seamless travel experience."
},
{
"name": "Pune Badami Travel Bus",
"description": "Pune Badami Travel Bus offers organized bus travel for visitors heading to Badami’s famous cave temples and heritage sites. With comfortable seating, experienced drivers, and well-planned routes, this service ensures a smooth and enjoyable long-distance journey."
},
{
"name": "Tourist Bus Hampi Badami",
"description": "Tourist Bus Hampi Badami caters to travelers exploring the iconic monuments, temples, and landscapes of Hampi and Badami. Flexible itineraries, comfortable buses, and professional drivers make sightseeing convenient and enjoyable for tourists and travel groups."
},
{
"name": "Outstation Bus Pune",
"description": "Outstation Bus Pune provides dependable long-distance bus services for interstate travel, including Karnataka heritage tours. Designed for comfort and safety, this service includes well-maintained buses, trained drivers, and reliable scheduling for extended journeys."
},
{
"name": "Online Bus Booking Pune",
"description": "Online Bus Booking Pune allows travelers to easily reserve buses for Hampi and Badami tours with quick confirmation. Multiple bus options, flexible schedules, and a simple booking process help travelers plan their heritage trips efficiently and without hassle."
},
{
"name": "Karnataka Tour Bus",
"description": "Karnataka Tour Bus offers comprehensive bus travel solutions for exploring Karnataka’s cultural and historical destinations. From Pune to Hampi and Badami, this service ensures comfortable buses, experienced chauffeurs, and well-organized travel for a memorable heritage tour experience."
}
],
"tableData": [
["Pune to Hampi Badami Bus On Rent Services", "Hampi Badami Bus Hire from Pune"],
["AC Bus Pune to Hampi", "Luxury Bus Hampi Badami Tour"],
["Heritage Tour Bus Pune", "Family Hampi Badami Trip"],
["Group Travel Hampi Bus", "Affordable Hampi Bus Rental"],
["Chauffeur Driven Bus Hampi", "Best Bus Service Pune to Hampi"],
["Pune Badami Travel Bus", "Tourist Bus Hampi Badami"],
["Outstation Bus Pune", "Online Bus Booking Pune"],
["Karnataka Tour Bus", "—"]
]
,


"whychoose": [
  {
    "WhyChooseheading": "Pune to Hampi Badami Bus on Rent Services with Sanavi Travels",
    "WhyChoosedescription": "Sanavi Travels offers reliable and comfortable bus rental services from Pune to Hampi and Badami, ideal for long-distance trips, group tours, pilgrimages, and historical sightseeing journeys."
  },
  {
    "WhyChooseheading": "Spacious and Well-Maintained Buses",
    "WhyChoosedescription": "Our buses are clean, air-conditioned, and regularly serviced to ensure a smooth and enjoyable journey from Pune to Hampi and Badami."
  },
  {
    "WhyChooseheading": "Experienced and Professional Drivers",
    "WhyChoosedescription": "Our licensed and courteous drivers are familiar with long-distance routes from Pune to Hampi and Badami, ensuring safe, timely, and stress-free travel for your group."
  },
  {
    "WhyChooseheading": "Transparent Pricing with No Hidden Charges",
    "WhyChoosedescription": "Sanavi Travels provides upfront and clear pricing for Pune to Hampi Badami bus rentals, including fuel, tolls, and driver allowances with no hidden fees."
  },
  {
    "WhyChooseheading": "24/7 Customer Support",
    "WhyChoosedescription": "Our customer support team is available round the clock to help with bookings, travel queries, and itinerary planning for your Pune to Hampi Badami trip."
  },
  {
    "WhyChooseheading": "Flexible Rental Packages",
    "WhyChoosedescription": "Choose from one-way, round-trip, or customized rental plans to match your group’s travel schedule and requirements."
  },
  {
    "WhyChooseheading": "Safe and Sanitized Vehicles",
    "WhyChoosedescription": "All buses are thoroughly cleaned and sanitized before every trip to ensure a safe and hygienic travel experience."
  },
  {
    "WhyChooseheading": "Reliable and On-Time Service",
    "WhyChoosedescription": "We guarantee punctual pickups and dependable service, making Sanavi Travels a trusted choice for Pune to Hampi Badami bus rentals."
  }
]

}

const faqData = [
  {
    question: 'Does Sanavi Travels provide bus rental services from Pune to Hampi and Badami?',
    answer: 'Yes, Sanavi Travels offers reliable and comfortable bus rental services from Pune to Hampi and Badami for group travel and sightseeing.'
  },
  {
    question: 'How can I book a Pune to Hampi Badami bus?',
    answer: 'You can book easily through our website or by contacting our 24x7 customer support team.'
  },
  {
    question: 'What types of buses are available for Pune to Hampi Badami trips?',
    answer: 'Sanavi Travels offers a variety of buses including mini buses, 20-seater, 32-seater, 45-seater, and 50-seater options for your long-distance journey.'
  },
  {
    question: 'Are the drivers experienced with long-distance routes?',
    answer: 'Yes, our drivers are licensed, professional, and familiar with long-distance routes, ensuring safe and timely travel from Pune to Hampi and Badami.'
  },
  {
    question: 'Can I customize the pickup and drop-off locations?',
    answer: 'Absolutely — you can select your preferred pickup and drop-off locations in Pune and destinations en route or at Hampi/Badami.'
  },
  {
    question: 'Is the Pune to Hampi Badami bus service available 24x7?',
    answer: 'Yes, Sanavi Travels offers round-the-clock support to help you plan and book your bus for this long-distance trip.'
  },
  {
    question: 'Are the buses sanitized before every trip?',
    answer: 'Yes, all buses are thoroughly cleaned and sanitized to ensure a safe and hygienic travel experience.'
  },
  {
    question: 'What payment options are available?',
    answer: 'We accept UPI, credit/debit cards, digital wallets, bank transfers, and corporate payments for your bus bookings.'
  },
  {
    question: 'Is customer support available during the bus journey?',
    answer: 'Yes, our 24x7 customer support team is available throughout your Pune to Hampi Badami trip.'
  }
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Rajesh Kulkarni',
    feedback: 'Hired a bus from Pune to Hampi and Badami with Sanavi Travels — extremely comfortable journey and excellent service!',
    rating: 5
  },
  {
    id: 2,
    name: 'Ms. Anjali Patil',
    feedback: 'Our group trip from Pune to Hampi/Badami was seamless thanks to Sanavi Travels — comfortable bus and professional driver!',
    rating: 5
  }
];













































































































































































  const Images = [
    { place: "/images/keyword/1.jpg", text: "Tempo Traveller On Rent in Pune", link: "tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/2.jpg", text: "Pune to Shirdi Tempo Traveller On Rent", link: "pune-to-shirdi-tempo-traveller-on-rent" },
    { place: "/images/keyword/3.jpg", text: "Pune to Mahabaleshwar Tempo Traveller on Rent", link: "pune-to-mahabaleshwar-tempo-traveller-on-rent" },
    { place: "/images/keyword/4.jpg", text: "Pune to Goa Tempo Traveller Hire", link: "pune-to-goa-tempo-traveller-hire" },
    { place: "/images/keyword/5.jpg", text: "Pune to Mumbai Tempo Traveller on Rent", link: "pune-to-mumbai-tempo-traveller-on-rent" },
    { place: "/images/keyword/6.jpg", text: "Pune to Konkan Darshan Tempo Traveller Hire", link: "pune-to-konkan-darshan-tempo-traveller-hire" },
    { place: "/images/keyword/7.jpg", text: "Pune to Nashik Tempo Traveller On Rent", link: "pune-to-nashik-tempo-traveller-on-rent" },
    { place: "/images/keyword/8.jpg", text: "Tempo Traveller On Rent for Pune Darshan", link: "tempo-traveller-on-rent-for-pune-darshan" },
    { place: "/images/keyword/9.jpg", text: "Mini Bus On Rent in Pune", link: "mini-bus-on-rent-in-pune" },
    { place: "/images/keyword/10.jpg", text: "13 Seater Tempo Traveller On Rent in Pune", link: "13-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/11.jpg", text: "17 Seater Tempo Traveller on Rent in Pune", link: "17-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/12.jpg", text: "20 Seater Luxury Bus On Rent Pune", link: "20-seater-luxury-bus-on-rent-pune" },
    { place: "/images/keyword/13.jpg", text: "26 Seater Tempo Traveller On Rent in Pune", link: "26-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/14.jpg", text: "32 Seater Luxury Bus On Rent in Pune", link: "32-seater-luxury-bus-on-rent-in-pune" },
    { place: "/images/keyword/15.jpg", text: "35 Seater Bus on Rent in Pune", link: "35-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/16.jpg", text: "45 Seater Bus On Rent in Pune", link: "45-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/17.jpg", text: "50 Seater Bus On Rent in Pune", link: "50-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/18.jpg", text: "Bus Hire for School Trips in Pune", link: "bus-hire-for-school-trips-in-pune" },
    { place: "/images/keyword/19.jpg", text: "Bus booking for Wedding in Pune", link: "bus-booking-for-wedding-in-pune" },
    { place: "/images/keyword/20.jpg", text: "Bus Booking for Marriage in Pune", link: "bus-booking-for-marriage-in-pune" },
    { place: "/images/keyword/21.jpg", text: "Bus Service for Corporate in Pune", link: "bus-service-for-corporate-in-pune" },
    { place: "/images/keyword/22.jpg", text: "Bus on Rent For Event in Pune", link: "bus-on-rent-for-event-in-pune" },
    { place: "/images/keyword/23.jpg", text: "Bus Hire for Outstation in Pune", link: "bus-hire-for-outstation-in-pune" },
    { place: "/images/keyword/24.jpg", text: "AC Bus On Rent in Pune", link: "ac-bus-on-rent-in-pune" },
    { place: "/images/keyword/25.jpg", text: "Pune Bus Hire Rental Service", link: "pune-bus-hire-rental-service" },
  ];




const jsonData = {
  "@context": "https://schema.org",
  "@type": "BusTrip",
  "name": "Pune to Hampi Badami Bus On Rent Services - Sanavi Travels",
  "description": "Sanavi Travels provides Pune to Hampi Badami bus on rent services with AC and luxury buses. Ideal for heritage tours, family trips, group travel, and outstation travel. Affordable and chauffeur-driven buses available with online booking.",
  "touristType": "Heritage Tour, Family Trip, Group Travel, Outstation Travel",
  "departureLocation": "Pune",
  "arrivalLocation": "Hampi, Badami",
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "25"
  }
};











  return (
    <div>
<Helmet>
  <title>
    Pune to Hampi Badami Bus On Rent Services | Sanavi Travels
  </title>

  <meta
    name="description"
    content="Pune to Hampi Badami bus on rent services by Sanavi Travels. AC and luxury buses for heritage tours, family trips, group travel, and outstation travel. Affordable, chauffeur-driven with online booking."
  />

  <script type="application/ld+json">
    {JSON.stringify(jsonData)}
  </script>
</Helmet>


      <div className="page-headder bg-section parallaxie">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="page-header-box text-white">
                <h1 className="text-anime-style-3 text-center text-white" data-cursor="-opaque">
                  <h3> {cardData.keyword}</h3>
                </h1>
              </div>
            </div>
          </div>
        </div>
      </div>





      <section>
        <div className="container-fluid" >
          <div className="row container-fluid p-0">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/195.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>



              <div className="shambhu-services">
                {cardData.services.map((service, index) => (
                  <div key={index} className="sh-service-card">

                    <div className="sh-service-left">
                      <div className="sh-service-icon">
                        🚖
                      </div>
                    </div>

                    <div className="sh-service-content">
                      <h4 className="sh-service-title">{service.name}</h4>
                      <p className="sh-service-desc">{service.description}</p>
                    </div>

                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Sanavi Travels </span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Sanavi Travels </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+917387507373" className="pc-call">+91 7387507373</a>
                      <a href="tel:+919595532929" className="pc-call">+91 9595532929</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/917387507373"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+917387507373" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@sanavitravels.com" className="pc-email">
                      booking@sanavitravels.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Sanavi Travels</strong><br />
                      OFFICE NO.6, GROUND FLOOR GAT NO.1110,
                      SHREE GOPINATH MAHARAJ VYAPARI SHED SHIVAJI CHOWK, VARVAND TAL DAUND,
                      DIST PUNE – 412215
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Punetohampibadambusonrentservice;